/**
 * Reusable stateless form component for CertificateTemplate
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import { EditorState, convertToRaw } from 'draft-js';

import VideoTrackListItem from '../../scene/components/VideoTrackListItem.js.jsx'

// import form components
import {
  CdnPathInput
  , CheckboxInput
  , NumberInput
  , RadioInput
  , RichEditor
  , SelectFromArray
  , TextAreaInput
  , TextInput
  , UrlInput
} from '../../../global/components/forms';

function CertificateTemplateForm({
  cancelLink
  , certificateTemplate
  , formHelpers
  , formTitle
  , formType
  , handleTrackFormChange
  , handleFormChange
  , handleFormSubmit
}) {
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;
  console.log(formHelpers)
  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="certificate-templateForm" className="certificate-template-form" onSubmit={handleFormSubmit}>
            {header}
            <div className="-form-step"><span className="-num">1</span>General Info</div>
            <p>For admin purposes only. Will not display on the certificate itself. </p>
            <div className="yt-col full m_60">
              <TextInput
                change={handleFormChange}
                label="Certificate Template Name"
                name="certificateTemplate.name"
                required={true}
                value={certificateTemplate.name}
              />
              <TextInput
                change={handleFormChange}
                helpText="Will default to 'This certifies that'"
                label="Custom 'Certifies' text"
                name="certificateTemplate.certifiesText"
                required={false}
                value={certificateTemplate.certifiesText}
              />
              <TextInput
                change={handleFormChange}
                helpText="Will default to 'has successfully completed'"
                label="Custom 'has completed' text"
                name="certificateTemplate.hasCompletedText"
                required={false}
                value={certificateTemplate.hasCompletedText}
              />
              <TextInput
                change={handleFormChange}
                helpText="i.e. the text that comes after the credits earned. Will default to inheriting content module's creditType field."
                label="Custom 'Credits Earned' suffix"
                name="certificateTemplate.creditsEarnedSuffix"
                required={false}
                value={certificateTemplate.creditsEarnedSuffix}
              />
            </div>
            <div className="-form-step"><span className="-num">2</span> Signer Info </div>
            <p>Information about the person responsible for signing the certificate. </p>
            <div className="yt-col full m_60">
              <UrlInput
                change={handleFormChange}
                helpText="Ideal size is 300px width by 80px height"
                label="URL for Signature Image"
                name="certificateTemplate.signerImageUrl"
                required={true}
                value={certificateTemplate.signerImageUrl}
              />
              <TextInput
                change={handleFormChange}
                label="Signator's Full Name"
                name="certificateTemplate.signerName"
                required={true}
                value={certificateTemplate.signerName}
              />
              <TextInput
                change={handleFormChange}
                helpText=""
                label="Signator's Position"
                name="certificateTemplate.signerPosition"
                required={true}
                value={certificateTemplate.signerPosition}
              />
            </div>
            <div className="-form-step"><span className="-num">3</span> Partner Info </div>
            <p>This info lives at the top center of the certificate.</p>
            <div className="yt-col full m_60">
              <UrlInput
                change={handleFormChange}
                helpText="Should be 300px wide. Height doesn't matter."
                label="URL for the Partner's Logo"
                name="certificateTemplate.partnerLogoUrl"
                required={false}
                value={certificateTemplate.partnerLogoUrl}
              />
            </div>
            <div className="-form-step"><span className="-num">4</span>Accreditation Body Info </div>
            <p>This is the information displayed in the bottom left corner of the certificate. </p>
            <div className="yt-col full m_60">
              <UrlInput
                change={handleFormChange}
                helpText="Should be 300px wide. Height doesn't matter."
                label="URL for the Accreditation Body Logo"
                name="certificateTemplate.accreditationLogoUrl"
                required={false}
                value={certificateTemplate.accreditationLogoUrl}
              />
              <TextAreaInput
                change={handleFormChange}
                label="Description for the Accreditation Body"
                name="certificateTemplate.accreditationDescription"
                required={false}
                value={certificateTemplate.accreditationDescription}
              />
            </div>
            <div className="-form-step"><span className="-num">5</span>Sponsor/Bottom-Right Info </div>
            <p>Template can either use sponsor logo (if it exists on the content module), an override logo (b2b partner for example), or leave this area blank.</p>
            <RadioInput
              label="Bottom right options"
              options={[
                {val: 'useSponsorLogo', display: 'Use CM sponsor logo'},
                {val: 'overrideSponsorLogo', display: 'Override with custom logo'},
                {val: 'leaveBlank', display: 'Leave area blank'},
              ]}
              name="certificateTemplate.bottomRightStatus"
              value={certificateTemplate.bottomRightStatus}
              change={handleFormChange}
              inLine={false}
            />
            { certificateTemplate.bottomRightStatus === 'overrideSponsorLogo' ? 
              <div className="yt-col full m_60">
                <UrlInput
                  change={handleFormChange}
                  helpText="Should be 300px wide. Height doesn't matter."
                  label="URL for the Accreditation Body Logo"
                  name="certificateTemplate.bottomRightLogoUrl"
                  required={false}
                  value={certificateTemplate.bottomRightLogoUrl || ''}
                />
              </div> 
              :
              null 
            }
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > Save </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

CertificateTemplateForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , certificateTemplate: PropTypes.object.isRequired
  , formHelpers: PropTypes.object
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
}

CertificateTemplateForm.defaultProps = {
  formHelpers: {}
  , formTitle: ''
}

export default CertificateTemplateForm;



// WEBPACK FOOTER //
// modules/certificateTemplate/components/CertificateTemplateForm.js.jsx